<template>
	<div class="resource-filter panel">
		<a class="resource-filter-toggle collapsed" :href="`#${facetName}-options`" data-toggle="collapse" data-parent="#resourceFilters" aria-expanded="false" :aria-controls="`${facetName}-options`" role="button" :data-testid="`${facetName}-toggle`">
			<h2 class="h6 resource-filter-label">
				<span class="m-r-xs">{{ facetLabel }}:</span><br class="hidden-sm-up">
				<span v-if="selectedFilter" class="reset-text" :data-testid="`${facetName}-toggle-label`">{{ selectedFilter.value.split('|')[0] }}</span>
			</h2>
			<div class="show-filter-options">
				<span class="ico-arrow-down"></span><span class="sr-only">Show Filter Options</span>
			</div>
			<div class="hide-filter-options">
				<span class="ico-arrow-up"></span><span class="sr-only">Hide Filter Options</span>
			</div>
		</a>
		<div :id="`${facetName}-options`" class="collapse fade" :data-testid="`${facetName}-options`">
			<div class="collapse-scroller">
				<label v-for="(option, index) in availableChoices" :key="option.key + index" :for="option.key" class="resource-filter-option" :class="{'disabled': !option.enabled, 'checked': option.isSelected}">
					<input :id="option.key" :name="facetName" type="radio" @change="handleStateChanged(option.key, false)" :disabled="!option.enabled" :checked="option.isSelected">
					{{ option.value }}
					<span v-if="!option.enabled" class="no-results-flag h6">No Availability</span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'ResourceBookingFiltersSingleSelect',
	props: {
		facetLabel: {
			type: String,
			default: null
		},
		facetName: {
			type: String,
			default: null
		},
		choices: {
			type: Array,
			default: () => []
		},
		isWaiting: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selectedFilter() {
			return this.choices.find(c => c.isSelected);
		},
		availableChoices() {
			return this.choices.filter(c => c.available);
		}
	},
	methods: {
		handleStateChanged(selectedFilterKey, applyFilters) {
			const selectedFilter = this.choices.find((choice => choice.key === selectedFilterKey));
			this.choices.forEach(choice => choice.isSelected = false);
			selectedFilter.isSelected = true;
			if (selectedFilter) {
				this.$emit('change', this.facetName, selectedFilter, applyFilters);
			}
		}
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/resourceBookingFiltersSingleSelect.scss";
</style>
